import CircularProgress from '@material-ui/core/CircularProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import MoneyIcon from '@material-ui/icons/LocalAtm'
import CheckAndPullIcon from '@material-ui/icons/SyncProblem'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    hwCheckAndPullOrders,
    hwInventoryAvailability,
    hwPushYearPrices
} from '../../../../../api/hostelWorldApi/hwSync'
import { selectCurrentOrganization } from '../../../../../selectors/hostelworldSelectors/hwCurrentOrganization'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        width: '95%'
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class SyncTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        hwPushYearPrices: PropTypes.func,
        hwCheckAndPullOrders: PropTypes.func,
        hwInventoryAvailability: PropTypes.func,
        pendingPushYearPrices: PropTypes.bool,
        pendingCheckAndPullOrders: PropTypes.bool,
        pendingInventoryAvailability: PropTypes.bool,
        organizationId: PropTypes.number.isRequired
    }

    handlePushYearPrices = () => this.props.hwPushYearPrices({ organizationIds: [this.props.organizationId] })
    handleCheckAndPullOrders = () => this.props.hwCheckAndPullOrders({ organizationId: this.props.organizationId })
    handleInventoryAvailability = () =>
        this.props.hwInventoryAvailability({ organizationIds: [this.props.organizationId] })

    render() {
        const { classes, pendingPushYearPrices, pendingCheckAndPullOrders, pendingInventoryAvailability } = this.props

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <List>
                        <ListItem button onClick={this.handlePushYearPrices} disabled={pendingPushYearPrices}>
                            <ListItemIcon>
                                <MoneyIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить цены"
                                secondary="Это действие отправляет цены в HostelWorld.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearPrices && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem button onClick={this.handleCheckAndPullOrders} disabled={pendingCheckAndPullOrders}>
                            <ListItemIcon>
                                <CheckAndPullIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Проверить и вытащить заказы"
                                secondary="Это действие проверяет есть ли в HostelWorld.com новые заказы и если есть, то вытаскивает их в EasyMS"
                            />
                            <ListItemSecondaryAction>
                                {pendingCheckAndPullOrders && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handleInventoryAvailability}
                            disabled={pendingInventoryAvailability}
                        >
                            <ListItemIcon>
                                <EventAvailableIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Inventory доступности"
                                secondary="Это действие сравнивает доступность в HostelWorld.com с доступностью в EasyMS. Если доступность в EasyMS отличается, то она будет пересчитана и отправлена в HostelWorld.com"
                            />
                            {pendingInventoryAvailability && <CircularProgress className={classes.progress} />}
                        </ListItem>
                    </List>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    organizationId: selectCurrentOrganization(state),
    pendingPushYearPrices: state.hwSync.pendingPushYearPrices,
    pendingCheckAndPullOrders: state.hwSync.pendingCheckAndPullOrders,
    pendingInventoryAvailability: state.hwSync.pendingInventoryAvailability
})

export default connect(
    mapStateToProps,
    {
        hwPushYearPrices,
        hwCheckAndPullOrders,
        hwInventoryAvailability
    }
)(withStyles(styles)(SyncTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/SyncTab/SyncTab.js